import { render, staticRenderFns } from "./StatisticOrderCashFlowDetailsDialog.vue?vue&type=template&id=f4b6b3d2&"
import script from "./StatisticOrderCashFlowDetailsDialog.vue?vue&type=script&lang=ts&"
export * from "./StatisticOrderCashFlowDetailsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports